<template>
    <header class="app-header" role="banner">
        <div class="app-title">
            <span class="app-title-text">Data Contributors</span>
            <div class="text-muted last-updated"
                ><small>Updated daily at 10:45 PM ET</small></div
            >
        </div>

        <a
            href="http://healtheconnections.org"
            title="Return to HealtheConnections website"
        >
            <img
                alt="HealtheConnections myData"
                class="app-logo d-sm-none"
                src="../assets/symbol.png"
            />
            <img
                alt="HealtheConnections myData"
                class="app-logo d-none d-sm-inline-block"
                src="../assets/logo.png"
            />
        </a>
    </header>
</template>

<script>
export default {
    name: "AppHeader"
};
</script>

<style lang="scss">
.app-header {
    position: relative;
    @include flex-center-y;
    flex-direction: row;
    justify-content: space-between;
    flex-shrink: 0;
    padding: $spacer $spacer 0.75rem $spacer;
    background: $white;
    border-width: $spacer-1 0 0 0;
    border-style: solid;
    border-image: linear-gradient(to right, $orange, $hec-orange) 1;
    box-shadow: 0 0 $spacer-2 rgba(0, 0, 0, 0.25);
    overflow: hidden;
    z-index: 1;

    .app-title {
        flex: 1;

        .app-title-text {
            display: block;
            font-size: 1.25rem;
            color: $hec-blue;
            line-height: 1;
            margin-bottom: $spacer-2;
        }

        .last-updated {
            line-height: 1;
        }
    }

    .app-logo {
        height: 36px;
        width: auto;
    }

    @include media-breakpoint-up(sm) {
        .app-title .app-title-text {
            font-size: 1.75rem;
        }

        .app-logo {
            height: 48px;
        }
    }

    @media print {
        padding: 0 0 $spacer-4 0;
        background: transparent;
        border: 0;
        box-shadow: none;
    }
}
</style>
